<template>
	<div class="reading" :class="cssClass">
		<div class="value" v-html="value"></div>
	</div>
</template>

<script>
import Readings from '@/utils/readings'
export default {
	props: [
		'reading'
	],
	computed: {
		cssClass () {
			return Readings.readingTypes.get(parseInt(this.reading.type_id)).cssClass
		},
		unitHtml () {
			return Readings.readingTypes.get(parseInt(this.reading.type_id)).unitHtml
		},
		value () {
			switch (this.reading.type_id) {
				case Readings.TYPE_BLOOD_PRESSURE:
					return `<div class="max">${this.reading.values.diastolic_last}</div><div class="min">${this.reading.values.systolic_last}</div><div class="unit">${this.unitHtml}</div>`
				case Readings.TYPE_GEOFENCING:
					return `<div class="last">${this.reading.values.latitude.toFixed(2)}<br>${this.reading.values.longitude.toFixed(2)}</div>`
				case Readings.TYPE_CALORIES:
					return `<div class="last">${this.reading.values.value}</div><div class="unit">${this.unitHtml}</div>`
				case Readings.TYPE_PEDOMETER:
					return `<div class="last">${this.reading.values.value}</div><div class="unit">${this.$t('readings.pedometer.unit')}</div>`
				case Readings.TYPE_FALLS:
					return `<div class="fall">${this.$t('labels.general.fall')}</div>`
				default:
					return `<div class="last">${this.reading.values.last}</div><div class="unit">${this.unitHtml}</div>`
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/widgets/biometric/BiometricReading.vue